var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.colorClass},[(_vm.alarmStatus)?_c('i',{staticClass:"fas fa-bell",attrs:{"aria-hidden":"true"}}):_c('i',{staticClass:"fas fa-bell-slash",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }